export default theme => ({

  root: {
    textAlign: 'center',
    height: `calc(100% - ${theme.spacing.unit * 10}px)`,
    paddingTop: theme.spacing.unit * 10
  }

})



// WEBPACK FOOTER //
// ./src/styles/components/App.js